export default function (state = [], action) {
    switch (action.type) {
        case "ORGANISATION_SELECTED":
            return action.payload;
        default:
            return state;
    }
}